import axios from '../axiosServicesAgendamentos';

async function GetValidCriteria() {
  const payload: {
    PaginaAtual: number;
    TotalItensRetorno: number;
    CodigoCategoriaLocal?: number | undefined
  } = {
    PaginaAtual: 1,
    TotalItensRetorno: 20,
  };
  const response = await axios.get('admin/criterios/v1/criterios-validos', { params: payload });
  return response;
}
async function GetAllCriteria() {
  const payload: {
    PaginaAtual: number;
    TotalItensRetorno: number;
    CodigoCategoriaLocal?: number | undefined
  } = {
    PaginaAtual: 1,
    TotalItensRetorno: 20,
  };
  const response = await axios.get('admin/criterios/v1', { params: payload });
  return response;
}

async function newCriterionVariable(
  nome: string,
  descricao: string,
  acumulativo: boolean,
  imgBase64: string,
  fileName: string,
  tipoCriterio: number,
  pontuacaoVariavel: Array<any>,
) {
  await axios.post('admin/criterios/v1', {
    nome,
    descricao,
    acumulativo,
    icone: fileName ? {
      nomeIcone: fileName,
      imagemBase64: imgBase64,
    } : null,
    tipoCriterio,
    pontuacaoVariavel,
  });
}

async function newCriterionSimple(
  nome: string,
  descricao: string,
  acumulativo: boolean,
  imgBase64: string,
  fileName: string,
  tipoCriterio: number,
  pontos: string,
  target: string,
) {
  await axios.post('admin/criterios/v1', {
    nome,
    descricao,
    acumulativo,
    icone: fileName ? {
      nomeIcone: fileName,
      imagemBase64: imgBase64,
    } : null,
    tipoCriterio,
    pontos,
    target,
  });
}

async function updateCriterionSimple(
  id: string,
  nome: string,
  descricao: string,
  acumulativo: boolean,
  imgBase64: string,
  fileName: string,
  tipoCriterio: number,
  pontos: string,
  target: string,
) {
  await axios.put(`admin/criterios/v1/${id}`, {
    id,
    nome,
    descricao,
    acumulativo,
    icone: fileName ? {
      nomeIcone: fileName,
      imagemBase64: imgBase64,
    } : null,
    tipoCriterio,
    pontos,
    target,
  });
}

async function updateCriterionVaraible(
  id: string,
  nome: string,
  descricao: string,
  acumulativo: boolean,
  imgBase64: string,
  fileName: string,
  tipoCriterio: number,
  pontuacaoVariavel: Array<any>,
) {
  await axios.put(`admin/criterios/v1/${id}`, {
    nome,
    descricao,
    acumulativo,
    icone: fileName ? {
      nomeIcone: fileName,
      imagemBase64: imgBase64,
    } : null,
    tipoCriterio,
    pontuacaoVariavel,
  });
}

export default {
  GetValidCriteria,
  GetAllCriteria,
  newCriterionSimple,
  updateCriterionSimple,
  newCriterionVariable,
  updateCriterionVaraible,
};
